export const stepValidations: Record<
  number,
  Record<number, { field: string; arrayName?: string; conditional?: boolean }[]>
> = {
  //Primer paso
  1: {
    // IdPersonType 1
    1: [
      { arrayName: "foundsOrigin", field: "foundsOrigin" },
      { arrayName: "foundsOrigin", field: "foundsOriginDocument" },
      { arrayName: "foundsOrigin", field: "foundsOriginFile" },
      { arrayName: "signatories", field: "name" },
      { arrayName: "signatories", field: "firstLastName" },
	  { arrayName: "signatories", field: "email" },
      { arrayName: "signatories", field: "documentFile" },
      { arrayName: "signatories", field: "documentNumber" },
      { arrayName: "signatories", field: "dateOfExpiration" },
      { arrayName: "signatories", field: "nationality" },
      { arrayName: "signatories", field: "dateOfBirth" },
      { arrayName: "signatories", field: "taxAddress" },
    ],
    // IdPersonType 2
    2: [
      { field: "activitySector" },
      { field: "lastExcerciseIncome" },
      { field: "lastExcerciseNetWorth" },
      { arrayName: "foundsOrigin", field: "foundsOrigin" },
      { arrayName: "foundsOrigin", field: "foundsOriginDocument" },
      { arrayName: "foundsOrigin", field: "foundsOriginFile" },
      { field: "taxAddress" },
      { field: "ocdeName", conditional: true },
      { field: "ocdeCountry", conditional: true },
      { field: "ocdeWebsite", conditional: true },
      { field: "ocdeRegistrationNumber", conditional: true },
    ],
  },
  //Segundo paso
  2: {
    // IdPersonType 2
    1: [
      { arrayName: "signatories", field: "activitySector" },
      { arrayName: "signatories", field: "lastExcerciseIncome" },
      { arrayName: "signatories", field: "position" },
      { arrayName: "signatories", field: "situation" },
    ],
    2: [
      { arrayName: "beneficialOwners", field: "name" },
      { arrayName: "beneficialOwners", field: "firstLastName" },
      { arrayName: "beneficialOwners", field: "taxCountry" },
      { arrayName: "beneficialOwners", field: "documentFile" },
      { arrayName: "beneficialOwners", field: "documentNumber" },
      { arrayName: "beneficialOwners", field: "nationality" },
      { arrayName: "beneficialOwners", field: "dateOfExpiration" },
      { arrayName: "beneficialOwners", field: "dateOfBirth" },
      { arrayName: "beneficialOwners", field: "participationPercentage" },
      { arrayName: "beneficialOwners", field: "beneficialOwnersFile" },
	  
    ],
  },
  //Tercer paso
  3: {
	  // IdPersonType 1
	  1: [
		{ arrayName: "contacts", field: "name" },
		{ arrayName: "contacts", field: "firstLastName" },
		{ arrayName: "contacts", field: "email" },
		{ arrayName: "contacts", field: "communicationType" },
	  ],
    // IdPersonType 2
    2: [
      { arrayName: "representatives", field: "representation" },
      { arrayName: "representatives", field: "representationType" },
      { arrayName: "representatives", field: "name" },
      { arrayName: "representatives", field: "firstLastName" },
      { arrayName: "representatives", field: "taxCountry" },
      { arrayName: "representatives", field: "documentFile" },
      { arrayName: "representatives", field: "documentNumber" },
      { arrayName: "representatives", field: "nationality" },
      { arrayName: "representatives", field: "dateOfExpiration" },
      { arrayName: "representatives", field: "dateOfBirth" },
      { arrayName: "representatives", field: "representativesDocumentFile" },
    ],
  },
  //Cuarto paso
  4: {
    // IdPersonType 2
    2: [
      { arrayName: "contacts", field: "name" },
      { arrayName: "contacts", field: "firstLastName" },
      { arrayName: "contacts", field: "email" },
      { arrayName: "contacts", field: "communicationType" },
    ],
  },
};
